/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-16 10:47:21
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-16 10:58:36
 * @Content: 报名前活动奖励模块
 */

import React, { FC, memo, useMemo } from "react";
import { IPostCreateTempDetail } from "../../../service/Index";
import "./index.less";

const PREFIX = "SignRewardModule";

type IProps = {
  tempDetail: IPostCreateTempDetail;
};

const SignRewardModule: FC<IProps> = memo(({ tempDetail }) => {
  const signRewardInfo = useMemo(() => {
    return tempDetail.reward_info;
  }, [tempDetail]);

  if (!signRewardInfo.show) {
    return null;
  } else {
    return (
      <div className={PREFIX}>
        {signRewardInfo.title ? (
          <div className={`${PREFIX}-title`}>·{signRewardInfo.title}·</div>
        ) : null}
        <div className={`${PREFIX}-body`}>
          {signRewardInfo.reward_items
            ? signRewardInfo.reward_items.map((item, index) => {
                return (
                  <div className={`${PREFIX}-bodyItem`} key={index}>
                    <div className={`${PREFIX}-bodyItemImg`}>
                      <img src={item.reward_img} />
                    </div>
                    <div className={`${PREFIX}-bodyItemInfo`}>
                      <div className={`${PREFIX}-bodyItemInfoTitle`}>
                        {item.title}
                      </div>
                      <div className={`${PREFIX}-bodyItemInfoSubTitle`}>
                        {item.sub_title}
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    );
  }
});

export default SignRewardModule;
